(function () {
    if (window.__hsInfBooted) return;      // the theme editor re-injects sections
    window.__hsInfBooted = true;

    var root = document.querySelector('[data-hs-inf]');
    if (!root) return;

    var loader  = root.querySelector('.hs-inf__loader');
    var moreBtn = root.querySelector('.hs-inf__more');
    var status  = root.querySelector('.hs-inf__status');
    var endNote = root.querySelector('.hs-inf__end');
    var errNote = root.querySelector('.hs-inf__error');
    var retry   = root.querySelector('.hs-inf__retry');
    var AUTO    = parseInt(root.getAttribute('data-auto-batches') || '2', 10);
    var LABEL   = root.getAttribute('data-batch-label') || 'more products loaded';

    /* Derived state. EVERY field here is recomputed by reset(); nothing may be
       cached across a grid replacement. */
    var grid, pager, sectionId, nextPg, lastPg, total, seen, io, ctrl;
    var busy = false, batches = 0, gen = 0;

    /* Own scroll restoration: the browser would otherwise restore an offset
       measured against a document nine pages taller, landing the shopper at the
       very bottom of a freshly-rendered single page. But 'manual' ALONE loses the
       shopper's place whenever bfcache does not hold (measured on staging: back
       from a PDP → scroll 0, batches gone, and the ?page=N URL written by
       replaceState renders as a standalone page-N — 16 cards they have never
       seen). So the position is saved on pagehide and the grid is REBUILT to
       match on the return load before scroll is restored; a bfcache hit needs
       none of this — its frozen DOM is already right — so its entry is
       discarded on pageshow. */
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    function saveKey() {
      var q = new URLSearchParams(location.search);
      q.delete('page');
      var qs = q.toString();
      return 'hsInf:' + location.pathname + (qs ? '?' + qs : '');
    }
    var restoring = false;   /* a rebuild is in flight — scroll is not yet meaningful */
    window.addEventListener('pagehide', function () {
      /* pagehide, not beforeunload — a beforeunload listener itself disqualifies
         the page from bfcache in some browsers, defeating the good path. */
      try {
        if (!grid) return;
        /* Mid-rebuild the document is still the short pre-splice one, so the
           current offset would replay WRONG against the rebuilt page next time.
           No restore beats a wrong restore. */
        if (restoring) return;
        sessionStorage.setItem(saveKey(), JSON.stringify({
          y: window.pageYOffset || document.documentElement.scrollTop || 0,
          t: Date.now()
        }));
      } catch (e) { /* storage unavailable: lose the restore, nothing else */ }
    });
    window.addEventListener('pageshow', function (e) {
      /* bfcache hit: the frozen document is already correct — drop the entry so
         it cannot replay onto a later, unrelated visit to this collection. */
      if (e.persisted) { try { sessionStorage.removeItem(saveKey()); } catch (err) {} }
    });

    function lastPageFrom(p) {
      var n = 1;
      p.querySelectorAll('a[href*="page="]').forEach(function (a) {
        var v = parseInt(new URLSearchParams(a.getAttribute('href').split('?')[1]).get('page'), 10);
        if (v > n) n = v;
      });
      return n;
    }

    function totalCount() {
      var el = document.getElementById('ProductCountDesktop') || document.getElementById('ProductCount');
      var m = el && el.textContent.replace(/,/g, '').match(/[0-9]+/);
      return m ? parseInt(m[0], 10) : 0;
    }

    function shown() { return grid ? grid.querySelectorAll(':scope > li').length : 0; }

    /* The list of cards. On collections `#product-grid` IS the <ul>; on the SEARCH page (Dawn's
       main-search) the id sits on a wrapper <div data-id> and the <ul class="product-grid"> is
       inside it — the same wrapper facets.js replaces. Resolve to the <ul> in both the live
       document and fetched section HTML. (2026-10-21: search had no infinite scroll because
       `#product-grid > li` matched nothing there.) */
    function gridUl(root) {
      var g = root.querySelector('#product-grid');
      if (!g) return null;
      if (g.tagName !== 'UL') return g.querySelector('ul.product-grid') || g.querySelector('ul') || null;
      return g;
    }

    function reset() {
      gen += 1;                                 // invalidate any in-flight response
      if (ctrl) ctrl.abort();                   // drop any page still in flight
      if (io) { io.disconnect(); io = null; }
      busy = false; batches = 0;
      loader.hidden = true; moreBtn.hidden = true;
      endNote.hidden = true; errNote.hidden = true;

      var host = document.getElementById('product-grid');
      grid  = gridUl(document);
      pager = document.querySelector('.pagination-wrapper');

      /* No grid, no pagination, or an empty result: hand navigation back to the
         theme rather than leaving the shopper with neither. */
      if (!host || !grid || !pager || !grid.querySelector(':scope > li')) {
        document.body.classList.remove('hs-inf-active');
        return;
      }

      sectionId = host.dataset.id || grid.dataset.id || '';
      nextPg = parseInt(new URLSearchParams(location.search).get('page') || '1', 10) + 1;
      lastPg = lastPageFrom(pager);
      total  = totalCount();
      seen   = new Set();
      grid.querySelectorAll(':scope > li a[href*="/products/"]').forEach(function (a) {
        seen.add(a.getAttribute('href').split('?')[0]);
      });

      if (!sectionId || nextPg > lastPg) {
        document.body.classList.remove('hs-inf-active');
        return;
      }
      /* Only take over the pagination when we started at page 1. A shopper who
         landed deep from a search result keeps the real controls, or they lose
         every earlier page with no way back. Appending still works. */
      if (nextPg === 2) document.body.classList.add('hs-inf-active');
      else document.body.classList.remove('hs-inf-active');
      arm();
    }

    function arm() {
      if (batches >= AUTO || !('IntersectionObserver' in window)) { showButton(); return; }
      var tail = grid.lastElementChild;
      if (!tail) return;
      io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) load(); }, { rootMargin: '600px 0px' });
      io.observe(tail);
      /* Catch-up: after a filter the grid shrinks, and if the shopper was
         scrolled deep the new last card can sit ABOVE the viewport. The
         observer only reports intersection CHANGES, so it would sit silent
         until they happened to scroll back up. Load straight away if we are
         already level with or past the trigger. */
      if (tail.getBoundingClientRect().bottom < window.innerHeight + 600) load();
    }

    function showButton() {
      if (io) { io.disconnect(); io = null; }
      moreBtn.textContent = total ? 'Load more (' + shown() + ' of ' + total + ')' : 'Load more';
      moreBtn.hidden = false;
    }

    function stop() {
      if (io) { io.disconnect(); io = null; }
      loader.hidden = true; moreBtn.hidden = true;
      endNote.hidden = false;
      status.textContent = 'All products loaded.';
    }

    function fail() {
      if (io) { io.disconnect(); io = null; }
      busy = false;
      loader.hidden = true; moreBtn.hidden = true;
      errNote.hidden = false;
      document.body.classList.remove('hs-inf-active');   // give the pagination back
    }

    function load() {
      if (busy || !grid) return;
      if (nextPg > lastPg) { stop(); return; }
      busy = true;
      if (io) { io.disconnect(); io = null; }
      loader.hidden = false; moreBtn.hidden = true; errNote.hidden = true;

      /* Section Rendering API: this section only, with every existing parameter
         (filters, sort) carried through so a filtered grid keeps paging. */
      var q = new URLSearchParams(location.search);
      q.set('page', String(nextPg));
      var url = location.pathname + '?section_id=' + encodeURIComponent(sectionId) + '&' + q.toString();

      ctrl = new AbortController();
      var mine = ctrl, myGen = gen;
      var timer = setTimeout(function () { mine.abort(); }, 12000);   // a stall must not spin forever

      fetch(url, { credentials: 'same-origin', signal: mine.signal })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          clearTimeout(timer);
          if (myGen !== gen) return;              // superseded by a filter/sort
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var ul = gridUl(doc);
          var items = ul ? ul.querySelectorAll(':scope > li') : [];

          var frag = document.createDocumentFragment(), fresh = [];
          Array.prototype.forEach.call(items, function (li) {
            var link = li.querySelector('a[href*="/products/"]');
            var key = link ? link.getAttribute('href').split('?')[0] : null;
            if (key && seen.has(key)) return;
            if (key) seen.add(key);
            /* Dawn's reveal animation never observes appended nodes, so leaving
               its class on makes the card settle, then snap back and re-animate
               up to 1.2s later. One animation system only. */
            li.classList.remove('scroll-trigger', 'animate--slide-in');
            li.removeAttribute('data-cascade');
            li.classList.add('hs-inf-new');
            li.style.setProperty('--hs-inf-i', fresh.length % 8);
            frag.appendChild(li);
            fresh.push(li);
          });

          busy = false;
          loader.hidden = true;

          if (!fresh.length) { stop(); return; }

          grid.appendChild(frag);
          requestAnimationFrame(function () {
            fresh.forEach(function (li) { li.classList.add('hs-inf-in'); });
          });

          /* Repaint wishlist hearts: appended cards otherwise render unsaved,
             and tapping one would silently REMOVE the saved product. */
          if (typeof window.hsWishlistPaint === 'function') window.hsWishlistPaint();
          document.dispatchEvent(new CustomEvent('hs:wishlist:repaint'));

          /* Keep whatever state Dawn's facets stored — writing null makes its
             popstate handler fall back to the page-load parameters. */
          history.replaceState(history.state, '', location.pathname + '?' + q.toString());

          nextPg += 1;
          batches += 1;
          status.textContent = fresh.length + ' ' + LABEL;

          if (nextPg > lastPg) { stop(); return; }
          arm();
        })
        .catch(function () {
          clearTimeout(timer);
          if (myGen !== gen) return;             // reset() moved on: not an error
          busy = false;
          fail();
        });
    }

    moreBtn.addEventListener('click', function () { batches = 0; load(); });
    retry.addEventListener('click', function () {
      errNote.hidden = true;
      document.body.classList.add('hs-inf-active');
      load();
    });

    /* Deep-linking writes ?page=N into the URL, and Dawn's facets read the URL
       when they build a filter request — so filtering after scrolling would
       render page N of the FILTERED set and silently hide its first N-1 pages.
       Clear the page number the instant a facet or sort is touched. Capture
       phase, and facets' own handler is debounced, so this always lands first. */
    function dropPageParam() {
      var q = new URLSearchParams(location.search);
      if (!q.has('page')) return;
      q.delete('page');
      var qs = q.toString();
      history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : ''));
    }
    ['#FacetFiltersForm', '#FacetFiltersFormMobile', '#FacetSortForm', '#FacetSortDrawerForm'].forEach(function (sel) {
      var f = document.querySelector(sel);
      if (f) f.addEventListener('input', dropPageParam, true);
    });
    document.addEventListener('input', function (e) {
      if (e.target && e.target.closest && e.target.closest('facet-filters-form')) dropPageParam();
    }, true);

    /* Dawn's facets.js replaces #ProductGridContainer.innerHTML on every filter
       and sort. That mutation is the signal to rebuild all state from scratch. */
    var container = document.getElementById('ProductGridContainer');
    /* audit 2026-10-21: a facets re-render is ALWAYS page 1 (filter pills and "Clear all" are clicks, not inputs, so the
       input hook above missed them; a later Back then kept a stale ?page=3 and the next batch skipped results 25–72) */
    if (container) new MutationObserver(function () { dropPageParam(); reset(); }).observe(container, { childList: true });

    /* Back-navigation restore (the bfcache-miss path). The return load renders
       ?page=N standalone, so pages 1..N-1 are fetched and inserted ABOVE the
       served items, in order, before scroll is restored — a bare scrollTo
       against the short page would just clamp to the bottom of an unfamiliar
       sub-page. Runs once per load; the entry is consumed on read so a later
       forward-visit or reload cannot replay stale state. */
    function maybeRestore() {
      var entry = null, key = saveKey();
      try {
        var raw = sessionStorage.getItem(key);
        if (raw) { sessionStorage.removeItem(key); entry = JSON.parse(raw); }
      } catch (e) { return; }
      if (!entry || typeof entry.y !== 'number') return;
      /* audit 2026-10-21: a FRESH visit (menu link, not Back) replayed the offset saved when the shopper left for a
         product — they landed near the footer and auto-load fired. Only back/forward (or a reload) may restore. */
      try { var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0]; if (nav && nav.type !== 'back_forward' && nav.type !== 'reload') return; } catch (e) {}
      if (entry.t && Date.now() - entry.t > 3600000) return;   /* resurrected old tab */
      var urlPg = parseInt(new URLSearchParams(location.search).get('page') || '1', 10);
      if (urlPg <= 1 || !grid || !sectionId) {
        /* Never paged past 1 (or the grid handed back control): the document is
           already the right one — just put the shopper back where they were. */
        if (entry.y > 0) requestAnimationFrame(function () { window.scrollTo(0, entry.y); });
        return;
      }
      var myGen = gen;
      var pages = [];
      for (var p = 1; p < urlPg; p++) pages.push(p);
      var frag = document.createDocumentFragment();
      restoring = true;
      function finish() {
        if (myGen !== gen || !grid) { restoring = false; return; }
        grid.insertBefore(frag, grid.firstElementChild);
        if (typeof window.hsWishlistPaint === 'function') window.hsWishlistPaint();
        document.dispatchEvent(new CustomEvent('hs:wishlist:repaint'));
        /* Full page-1..N context is back, so retaking the pagination is
           legitimate again; they were past the auto-load budget before, so
           return to the explicit button rather than surprise auto-loads. */
        batches = AUTO;
        document.body.classList.add('hs-inf-active');
        arm();
        requestAnimationFrame(function () { window.scrollTo(0, entry.y); });
        /* One corrective pass after images/layout settle — but only if the
           shopper has NOT interacted. Intent events (wheel/touch/key), not
           'scroll': our own scrollTo above fires 'scroll' too. */
        var interacted = false;
        function onIntent() { interacted = true; }
        ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
          window.addEventListener(ev, onIntent, { passive: true, once: true });
        });
        setTimeout(function () {
          ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
            window.removeEventListener(ev, onIntent);
          });
          restoring = false;
          if (interacted) return;
          var off = Math.abs((window.pageYOffset || 0) - entry.y);
          if (off > 150) window.scrollTo(0, entry.y);
        }, 250);
      }
      function step() {
        if (myGen !== gen) { restoring = false; return; }
        if (!pages.length) { finish(); return; }
        var pg = pages.shift();
        var q = new URLSearchParams(location.search);
        q.set('page', String(pg));
        fetch(location.pathname + '?section_id=' + encodeURIComponent(sectionId) + '&' + q.toString(), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            if (myGen !== gen) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var ul2 = gridUl(doc);
            (ul2 ? ul2.querySelectorAll(':scope > li') : []).forEach(function (li) {
              var link = li.querySelector('a[href*="/products/"]');
              var k = link ? link.getAttribute('href').split('?')[0] : null;
              if (k && seen.has(k)) return;
              if (k) seen.add(k);
              /* Restored context, not new arrivals — no reveal animation. */
              li.classList.remove('scroll-trigger', 'animate--slide-in');
              li.removeAttribute('data-cascade');
              frag.appendChild(li);
            });
            step();
          })
          .catch(function () { restoring = false; /* fail soft: the deep-link page stands, no scroll jump */ });
      }
      step();
    }

    reset();
    maybeRestore();
  })();
